import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { DEFAULT_LANG } from '@/constants';
import { SUPPORTED_LANGUAGES, normalizeLanguageCode } from '@/utils/language';

interface LanguageWrapperChildrenProps {
  currentLanguage: string;
}

interface LanguageWrapperProps {
  children: (props: LanguageWrapperChildrenProps) => ReactNode;
}

// Wrapper component to extract and provide language from URL
export const LanguageWrapper = ({ children }: LanguageWrapperProps) => {
  const params = useParams();

  // Extract language from URL parameter
  const urlLang = params.lang;
  const normalizedLang = urlLang ? normalizeLanguageCode(urlLang) : DEFAULT_LANG;

  // Validate language or use default
  const currentLanguage = SUPPORTED_LANGUAGES.includes(normalizedLang)
    ? normalizedLang
    : DEFAULT_LANG;

  const effectiveLanguage = currentLanguage;

  return children({ currentLanguage: effectiveLanguage });
};
